export default __webpack_public_path__ + "static/media/logo_dna.27dd91ef.svg";